import React from 'react'
import styled from "styled-components"

const Style = styled.div`
  margin-top: ${props => props.marginTop};
  margin-right: ${props => props.marginRight};
  margin-bottom: ${props => props.marginBottom};
  margin-left: ${props => props.marginLeft};
`

const Margin = ({marginTop, marginRight, marginBottom, marginLeft}) => {
    return <Style marginTop={marginTop} marginRight={marginRight} marginBottom={marginBottom} marginLeft={marginLeft}/>
}

export default Margin
